<template>
  <div id="autocomplete-container">
    <input
      ref="inputRef"
      id="autoComplete"
      type="text"
      placeholder="Zadej adresu..."
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import autoComplete from "@tarekraafat/autocomplete.js";
import { Top } from "../js/class/Top.js";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";
import "@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css";

import { inject } from "vue";
import L from "leaflet";

const map = inject("map");
const zavriSidebar = inject("Sidebar.zavri");

//import "../../node_modules/@tarekraafat/autocomplete.js/dist/css/autoComplete.css";

const inputRef = ref(null);
const queryCache = {};
const API_KEY = Top.mapy_cz_api_key;

const getItems = async (query) => {
  if (queryCache[query]) return queryCache[query];

  try {
    //`https://api.mapy.com/v1/geocode?query=zoo%20ostrava&lang=cs&limit=5&type=regional&type=regional.country&type=regional.region&type=regional.municipality&type=regional.municipality_part&type=regional.street&type=regional.address&type=poi&type=coordinate&apikey=MmLVl5rC1r9xB0twl3JW4-ywmrDEDz9fheFOtubxxQk`
    /*
    const url = `https://api.mapy.cz/v1/suggest?lang=cs&limit=10&type=poi&type=regional.address&type=regional.street&apikey=${API_KEY}&query=${encodeURIComponent(
      query
    )}`;
    */
    /*
    const url = `https://api.mapy.cz/v1/suggest?lang=cs&limit=10&country=cz&type=poi&&type=regional.region&type=regional.municipality&type=regional.municipality_part&type=regional.street&type=regional.address&apikey=${API_KEY}&query=${encodeURIComponent(
      query
    )}`;
    */
    /*
    const url =
      `https://api.mapy.cz/v1/suggest?lang=cs&limit=10` +
`&lang=cs` + // hledat jen v ČR
      `&country=cz` + // hledat jen v ČR
      `&type=poi` + // body zájmu
      `&type=regional.municipality` + // obce (např. Velké Hoštěřádky)
      `&type=regional.municipality_part` + // části obcí (např. Poruba)
      `&type=regional.street` + // ulice
      `&type=regional.address` + // adresy
      `&apikey=${API_KEY}` +
      `&query=${encodeURIComponent(query)}`;

*/
    const url =
      `https://api.mapy.cz/v1/suggest?lang=cs&limit=10` +
      `&lang=cs` + // hledat jen v ČR
      `&locality=cz` + // hledat jen v ČR
      `&type=poi` + // body zájmu
      `&type=regional` + // obce (např. Velké Hoštěřádky)
      `&type=coordinate` + // adresy
      `&apikey=${API_KEY}` +
      `&query=${encodeURIComponent(query)}`;
    const res = await fetch(url);
    const json = await res.json();
    //Lc.h("json", json);
    //Lc.log("json", json);
    /*const items = json.items.map((item) => ({
      name: item.name,
      label: item.label,
      location: item.location,
      fullData: item,
    }));
    */
    const items = json.items.map((item) => ({
      name: item.name,
      label: item.label,
      location: item.location,
      fullData: item,
    }));

    queryCache[query] = items;
    return items;
  } catch (e) {
    console.error("Chyba při získání návrhů:", e);
    return [];
  }
};

onMounted(() => {
  new autoComplete({
    selector: "#autoComplete",
    data: {
      src: async (query) => {
        const items = await getItems(query);
        return items;
      },
      keys: ["name"],
      cache: false,
    },
    placeHolder: "Zadej adresu...",
    resultItem: {
      element: (item, data) => {
        const d = data.value;
        item.innerHTML = `<div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
          ${d.name}, ${d.location}
        </div>`;
      },
      highlight: true,
    },
    events: {
      input: {
        selection: (event) => {
          const feedback = event.detail;
          inputRef.value.value = feedback.selection.value.name;
          Lc.log("Vybráno:", feedback.selection.value.fullData);

          const data = feedback.selection.value.fullData;
          /*
          const data = {
            name: "Mňukova 3022/24",
            label: "Adresa",
            position: {
              lon: 18.24213,
              lat: 49.80575,
            },
            bbox: [
              18.239322463504333, 49.80466692160735, 18.244936934030083,
              49.806841005100196,
            ],
            type: "regional.address",
            location: "Ostrava - Zábřeh, Česko",
            regionalStructure: [
              {
                name: "3022/24",
                type: "regional.address",
              },
              {
                name: "Mňukova",
                type: "regional.street",
              },
              {
                name: "Zábřeh",
                type: "regional.municipality_part",
              },
              {
                name: "Ostrava-Jih",
                type: "regional.municipality_part",
              },
              {
                name: "Ostrava",
                type: "regional.municipality",
              },
              {
                name: "okres Ostrava-město",
                type: "regional.region",
              },
              {
                name: "Moravskoslezský kraj",
                type: "regional.region",
              },
              {
                name: "Česko",
                type: "regional.country",
                isoCode: "CZ",
              },
            ],
            zip: "700 30",
          };
          */

          if (!map?.value) {
            Lc.err("Mapa není připravena.");
            return;
          }

          const lat = data.position.lat;
          const lon = data.position.lon;

          const customIcon = L.icon({
            iconUrl: "/img/leaflet/marker-icon-orange.png",
            iconRetinaUrl: "/img/leaflet/marker-icon-orange.png",
            shadowUrl: "/img/leaflet/marker-shadow.png",
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
          });

          L.marker([lat, lon], { icon: customIcon })
            .addTo(map.value)
            .bindPopup("Nalezeno: " + data.name)
            .openPopup();

          const latlng = L.latLng(lat, lon);
          map.value.setView([lat, lon], 15);
          //map?.value?.flyTo(latlng, 13);

          zavriSidebar();
        },
      },
    },
  });
});
</script>

<style scoped>
.autoComplete_results_list {
  z-index: 999;
}
.autoComplete_result {
  height: 300px; /* nebo více, dle potřeby */
  overflow-y: auto;
}
</style>
